// src/pages/OverviewPage.jsx
import React, { useEffect, useState } from "react";

function OverviewPage() {
    // Example: fetch these stats from your backend
    const [stats, setStats] = useState({
        newUsers: 0,
        subscribers: 0,
        interviews: 0,
    });

    useEffect(() => {
        // Placeholder for an async call, e.g.:
        // fetch("/api/overviewStats")
        //   .then(res => res.json())
        //   .then(data => setStats(data));

        // Mock data
        setStats({
            newUsers: 100,
            subscribers: 45,
            interviews: 1234,
        });
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Overview</h1>

            <div className="grid grid-cols-3 gap-4">
                {/* Card: New Users */}
                <div className="bg-white rounded shadow p-4">
                    <h2 className="text-xl font-semibold mb-2">New Users</h2>
                    <p className="text-2xl">{stats.newUsers}</p>
                </div>

                {/* Card: Subscribers */}
                <div className="bg-white rounded shadow p-4">
                    <h2 className="text-xl font-semibold mb-2">Subscribers</h2>
                    <p className="text-2xl">{stats.subscribers}</p>
                </div>

                {/* Card: Interviews Done */}
                <div className="bg-white rounded shadow p-4">
                    <h2 className="text-xl font-semibold mb-2">
                        Interviews Done
                    </h2>
                    <p className="text-2xl">{stats.interviews}</p>
                </div>
            </div>
        </div>
    );
}

export default OverviewPage;
